import { makeStyles, TableCell, TableRow, Typography } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import classnames from "classnames";
import { get } from "lodash";
import React from "react";
import { useQueryWithStore, useTranslate } from "react-admin";
import EventField from "./fields/EventField";

const useStyles = makeStyles({
	highCtr: {
		backgroundColor: `${red[100]}!important`,
	},
});

const DatagridRowExpanded = ({ record, events, filterValues, permissions }) => {
	const customClasses = useStyles();
	const hasUserIdFilter = get(filterValues, "user_id");
	const isInsights = permissions && permissions("insights");
	const isUser = permissions && permissions("user");
	const getGroupBy = () => {
		if (isInsights && !hasUserIdFilter) {
			return "group_by_user_and_bookmaker";
		} else if (isUser || hasUserIdFilter) {
			return "group_by_user_and_channel";
		}
		return "group_by_user_and_bookmaker";
	};
	const groupBy = getGroupBy();

	const translate = useTranslate();
	const { loading, loaded, data } = useQueryWithStore({
		type: "getList",
		resource: "stats",
		payload: {
			pagination: { page: 1, perPage: 100 },
			sort: {
				field: isUser && !isInsights ? "bookmaker_channel" : "bookmaker",
				order: "ASC",
			},
			filter: {
				...filterValues,
				...((isUser && !isInsights) || hasUserIdFilter
					? {
							bookmaker_id: get(record, "bookmaker_id"),
					  }
					: {
							user_id: get(record, "user_id"),
					  }),
				group_by: groupBy,
			},
		},
	});
	const isGroupByUserAndChannel = groupBy === "group_by_user_and_channel";
	if (loading) {
		return (
			<TableRow>
				<TableCell>&nbsp;</TableCell>
				<TableCell colSpan={events.length + (isGroupByUserAndChannel ? 2 : 1)}>
					{translate("resources.stats.loading")}
				</TableCell>
			</TableRow>
		);
	}

	return (
		loaded &&
		data.map((row, index) => {
			const ctr = get(row, "click_through_rate");
			const id = get(row, "id");
			const highCtr = id && ctr && ctr > 50 ? true : false;
			return (
				<TableRow
					key={id}
					className={classnames(highCtr ? customClasses.highCtr : {})}
				>
					<TableCell>&nbsp;</TableCell>
					<TableCell
						align="left"
						colSpan={isGroupByUserAndChannel && !hasUserIdFilter ? 2 : 1}
					>
						<Typography variant="overline">
							{get(
								row,
								(isUser && !isInsights) || hasUserIdFilter
									? "bookmaker_channel"
									: "bookmaker"
							)}
						</Typography>
					</TableCell>
					{events.map((event) => (
						<TableCell key={event.id} align="left">
							<EventField source={event.name} record={row} event={event} />
						</TableCell>
					))}
				</TableRow>
			);
		})
	);
};
export default DatagridRowExpanded;
